module.exports = __webpack_public_path__ + "static/media/icn-53-time.8a87fce9.svg";